import oyoOSMiddleware from './oyoOSMiddleware';
import logoutUserFromOyo360 from '../utils/logoutUserFromOyo360';

const oyo360Middleware = store => next => action => {
    return oyoOSMiddleware({ store, next, action, logoutAction: logoutUserFromOyo360 });
};

export default oyo360Middleware;
